<div class="step-header">
    <div *ngIf="showBackButton" class="step-header__back-button" (click)="goBack()">
        <app-icon iconName="chevron_left" iconSize="16px" color="var(--text-secondary)"  ></app-icon>
        <span class="step-header__back-text" [ngClass]="prefixClass">Volver</span>
    </div>
    <div class="step-header__title-container" [ngClass]="prefixClass">
        <h1 class="step-header__title" [ngClass]="prefixClass">{{title}}
            <button *ngIf="showIconAction" class="step-header__icon-action" (click)="iconActionClick($event)">
                <app-icon [iconSize]="isMobile ? '24px' : '32px'" iconName="info" color="var(--primary-color)"></app-icon>
            </button>
        </h1>
    </div>
</div>